import { AxUserAddress } from '@/types/AxUserType'
import { $axFrontendHelper } from '../services/$axFrontendHelper'
import { axApiPaths } from '@/AxApiPaths'
import { $axAuthState } from '../services/$axAuthStateManager'
import { $cart } from '../services/$cart'
import { $urlHelper } from '../services/$urlHelper'
import { $toast } from '@/services/$toast'

const is_int = (value) => {
  const int = /[0-9]/
  const isValid = int.test(value)
  if (!isValid) {
    return '数字で入力してください'
  }
}

const isNotEmpty = (value) => {
  const str = value.toString()
  if (str.match(/^[\s\t\r\n]*$/)) {
    return '入力必須です'
  }
}

const isZenkakuKana = (value) => {
  if (!value.match(/^[ァ-ヶー]*$/)) {
    return '全角カタカナで入力してください'
  }
}

const isTelNo = (value) => {
  const isValid = /^[\d|-]+$/.test(value)
  if (!isValid) {
    return '電話番号を正しく入力してください'
  }
}

// 市町村　文字制限
export const is_city_length = (value,name) => {
  const isValid =
    value.length <= 40
  if (!isValid) {
    return name + 'は40文字以内で入力してください'
  }
}

// 郵便
export const isZipcode = (value,name) => {
  const isValid = /^\d+$/.test(value) === true && value.length === 7
  if(!isValid){
   return '郵便番号は7桁の数字のみで正しく入力してください(ハイフンなし)'
  }
}

export interface DeliveryAddressColumns {
  name: string
  family_name: string
  reputation: string
  name_read: string
  family_name_kana: string
  reputation_kana: string
  tel_primary: string
  zip: string
  state: string
  city: string
  street: string
  building: string
}

export const deliveryAddressColumns = {
  name: '',
  family_name: '',
  reputation: '',
  name_read: '',
  family_name_kana: '',
  reputation_kana: '',
  tel_primary: '',
  zip: '',
  state: '',
  city: '',
  street: '',
  building: '',
}

const deliveryAddressFindAll = async () => {
  const fields = Object.keys(deliveryAddresses.columns).map((colName) => `address.${colName}`)
  const res = await $axFrontendHelper.request<{ addresses: AxUserAddress[] }>({
    path: axApiPaths.users.addresses.get,
    data: { request: { fields } },
  })
  return res
}

export const saveDeliveryAddress = async (data: DeliveryAddressColumns) => {
  data.name = data.family_name + ' ' + data.reputation
  data.name_read = data.family_name_kana + ' ' + data.reputation_kana
  return await deliveryAddresses.onSubmitFunction(data)
}
export const saveDeliveryAddressWithUserData = async (userData, addresses_id = null) => {
  const data = {
    id: addresses_id,
    name: userData.name,
    name_read: userData.name_read,
    tel_primary: userData.tel_primary,
    zip: userData.zip,
    state: userData.state,
    city: userData.city,
    street: userData.street,
    building: userData.building,
  }
  return await deliveryAddresses.onSubmitFunction(data)
}

export const deliveryAddresses = {
  columns: {
    id: {},
    name: {
      label: '名前',
    },
    name_read: {
      label: '名前カナ',
    },
    family_name: {
      label: '姓',
      validate: { isNotEmpty },
    },
    reputation: {
      label: '名',
      validate: { isNotEmpty },
    },
    family_name_kana: {
      label: 'セイ',
      validate: { isZenkakuKana, isNotEmpty },
    },
    reputation_kana: {
      label: 'メイ',
      validate: { isZenkakuKana, isNotEmpty },
    },
    zip: {
      label: '郵便番号',
      validate: { isNotEmpty, isZipcode },
    },
    state: {
      label: '都道府県',
      validate: { isNotEmpty },
    },
    city: {
      label: '市区郡町村',
      validate: { isNotEmpty,is_city_length },
    },
    street: {
      label: '町域番地',
      validate: { isNotEmpty },
    },
    building: {
      label: '建物名（部屋番号）',
    },
    tel_primary: {
      label: '電話番号',
      validate: { isTelNo, isNotEmpty },
    },
  },
  onSubmitFunction: async (data) => {
    try {
      // ログインしている場合にのみ、Axにお届け先を保存する
      if ($axAuthState.isLoggedIn) {
        if (!data.id) {
          delete data.id
        }
        data = formatUserDataForSave(data)
        await $axFrontendHelper.request({
           path: axApiPaths.users.addresses.put,
           data: { query: { address: data } },
         })
      }
    } catch (e) {
      console.log(e)
      $toast.error(
        'お届け先を保存できませんでした。正しくインターネットに接続できていることをご確認ください。また、再度時間をおいて試してみてください。'
      )
    }
    // カートにセット
    $cart.deliveryAddress = data
    return data
  },
  onDeleteFunction: async (data) => {
    if ($axAuthState.isLoggedIn) {
      const res = await $axFrontendHelper.request({
        path: `/users/addresses/delete`,
        data: { query: { 'address.id': data.id } },
      })
      return res
    }
  },
  overrides: {
    findAll: deliveryAddressFindAll,
  },
}

export const formatUserDataForSave = (data) => {
  // 名前
  if (data.name) {
    data.name = $urlHelper.escapeQueryParams(data.name)
  }
  // 名前フリガナ
  if (data.name_read) {
    data.name_read = $urlHelper.escapeQueryParams(data.name_read)
  }
  // 市区町村
  if (data.city) {
    data.city = $urlHelper.escapeQueryParams(data.city)
  }
  // 町村字番地
  if (data.street) {
    data.street = $urlHelper.escapeQueryParams(data.street)
  }
  // 建物名（部屋番号）
  if (data.building) {
    data.building = $urlHelper.escapeQueryParams(data.building)
  } else {
    data.building = ''
  }

  if(data.family_name && data.reputation){
    data.name = data.family_name + ' ' + data.reputation
  }

  if(data.family_name_kana && data.reputation_kana){
    data.name_read = data.family_name_kana + ' ' + data.reputation_kana
  }
  return data
}

/*
  バリデーション処理
*/
export const validate = async (data, errors) => {
  const colDef = deliveryAddresses.columns
  //let errors = {}
  //errors['flag'] = false
  errors.flag = false

  // エラーチェック処理
  for (const keyname in data) {
    errors[keyname] = {}
    if (colDef[keyname] && colDef[keyname].validate) {
      let err = []
      Object.keys(colDef[keyname].validate).map((key) => {
        let errorMessage = ''
        const labelname = colDef[keyname].label

        errorMessage = colDef[keyname].validate[key](data[keyname], labelname)
        // エラーの場合はエラー内容を追加
        if (errorMessage) {
          err.push(errorMessage)
        }
      })
      if (err.length !== 0) {
        errors[keyname].message = err
        errors[keyname].flag = true
        errors.flag = true
      }
    }
  }
  console.log('errors: ', errors)
  //return errors
}
